<template>
  <div>
    <Head title="Crear Producto" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/routes/sub-routes/list-day">Dia</Link>
      <span class="text-sky-400 font-medium">/</span> Editar dia
    </h1>
    <div class="max-w-7xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input 
            v-model="form.name" 
            :error="form.errors.name" 
            class="pb-8 pr-6 w-full lg:w-1/3" 
            label="Nombre de la sub-ruta" 
          />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Guardar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    subroute: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.subroute.name,
        _method: 'put',
      }),
    }
  },
  remember: 'form',
  methods: {
    update(){
      this.form.post(`/routes/sub-routes/update-day/${this.subroute.id}`)
    },
  },
}
</script>